$(document).ready(function() {
	if(!document.querySelector('.GPC0145')) return false;
	
	var $obj = $('.GPC0145');
	var $slick = $obj.find('.award-type:not(.under-2-item) .items').slick({
		infinite: false,
		autoplay: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		arrows : true,
		dots: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true
				}
			}
		],
		prevArrow: carouselOptions.squarePrev, // common.js variable
		nextArrow: carouselOptions.squareNext // common.js variable
	});
	var $slick2 = $obj.find('.award-type.under-2-item .items').slick({
		infinite: false,
		autoplay: false,
		responsive: [
			{
				breakpoint: 9999,
				settings: 'unslick'
			},
			{
				breakpoint: 1200,
				settings: {
					infinite: false,
					autoplay: false,
					slidesToShow: 2,
					slidesToScroll: 2,
					arrows : true,
					dots: false
				}
			},
			{
				breakpoint: 768,
				settings: {
					infinite: false,
					autoplay: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows : true,
					dots: true
				}
			}
		],
		prevArrow: carouselOptions.squarePrev, // common.js variable
		nextArrow: carouselOptions.squareNext // common.js variable
	});
	$(window).on('resize',function(){
		$slick.slick('resize');
		$slick2.slick('resize');
	}).resize();
	// link slick 
	/* PJTPLP-10 (황규하) whitespace관련 START */
	var $headLine = $('[data-headLine]');
	$headLine.each(function() {
		$headLine.find('span').remove();
	});
	$('.GPC0145').each(function(){
		var $obj = $(this);
		var r1 = false;
		var r2 = false;
		var r3 = false;
		var $r1El = $obj.find('[data-headLine]');
		var $r2El = $obj.find('[data-headCopy]');
		var $r3El = $obj.find('[data-bodyCopy]');
		$r1El.each(function(){
			var val = $(this).text();
			if (!r1) {
				if($.trim(val)){
					r1 = true;
					return r1;
				}
			}
		});
		if(!r1){
			$r1El.remove();
		}
		$r2El.each(function(){
			var val2 = $(this).text();
			if (!r2) {
				if($.trim(val2)){
					r2 = true;
					return r2;
				}
			}
		});
		if(!r2){
			$r2El.remove();
		}
		$r3El.each(function(){
			var val3 = $(this).text();
			if (!r3) {
				if($.trim(val3)){
					r3 = true;
					return r3;
				}
			}
		});
		if(!r3){
			$r3El.remove();
		}
	});
	/* PJTPLP-10 (황규하) whitespace관련 END */
});